// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"677":"e839c11e","763":"dae4f636"}[chunkId] + ".chunk.css";
};